import axios from "axios";
import Environment from '../Environment';
import { getAuthToken } from '../util/util'


const getRoute = Environment();

export class Service {
  //------> Link para hacer peticiones
  baseUrl = getRoute + "/";
  token = getAuthToken();
  config = {
    headers: {
      'Authorization': 'Bearer ' + this.token
    }
  }
  //------> Agregar nuevo registro
  login(entity) {
    return axios.post(this.baseUrl, entity).then((res) => res.data);
  }
  create(entity) {
    return axios.post(this.baseUrl, entity, this.config).then((res) => res.data);
  }
  //------> Obtener registros de BD
  readAll() {
    return axios.get(this.baseUrl, this.config).then((res) => res.data);
  }
  //------> Modificar registro
  update(entity) {
    return axios.put(this.baseUrl, entity, this.config).then((res) => res.data);
  }
  //------> Eliminar registro
  delete(id) {
    return axios.delete(this.baseUrl + "/" + id, this.config).then((res) => res.data);
  }

  findById(id) {
    return axios.get(`${this.baseUrl}/${id}`, this.config).then(res => res.data);
  }
  createReport(body) {
    let config = {
      headers: {
        'Authorization': 'Bearer ' + this.token
      },
      responseType: 'blob'
    }
    return axios.post(this.baseUrl, body, config).then((res) => res.data);
  }
  setPassword(entity) {
    return axios.post(this.baseUrl, entity).then((res) => res.data);
  }

}
